import { css } from '@emotion/react';
import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Title from 'components/Title/Title';
import Page from 'components/Page/Page';
import Runs from './Runs/Runs';
import Files from './Files/Files';
import fetchUsers from 'store/fetchUsers';
import getProjectId from 'utils/url/getProjectId';

export default function WorkflowRunsPage() {
  const [selectedRunIds, setSelectedRunIds] = useState<string[]>([]);
  const { pathname } = useLocation();
  const projectId = getProjectId();
  const selectionScope = projectId ?? pathname;
  const [prevSelectionScope, setPrevSelectionScope] = useState(selectionScope);
  if (prevSelectionScope !== selectionScope) {
    setPrevSelectionScope(selectionScope);
    setSelectedRunIds([]);
  }

  useEffect(() => {
    fetchUsers();
  }, [pathname, projectId]);

  const selectedRunId = selectedRunIds.length === 1 ? selectedRunIds[0] : undefined;

  return (
    <Fragment>
      <Title>Workflows | Tailor</Title>
      <Page>
        <div
          css={css`
            margin: 48px;

            @media (max-width: 767px) {
              margin: 12px;
            }

            display: flex;
            flex-direction: column;
            gap: 24px;
          `}
        >
          <Runs selectedRunIds={selectedRunIds} setSelectedRunIds={setSelectedRunIds} />
          {selectedRunId && <Files runId={selectedRunId} />}
        </div>
      </Page>
    </Fragment>
  );
}
